import List from './List.vue'
import Form from './Form.vue'
import TestForm from './TestForm.vue'

export default {
  install (Vue) {
    Vue.component('accounts-list', List)
    Vue.component('accounts-form', Form)
    Vue.component('accounts-test-form', TestForm)
  }
}



// WEBPACK FOOTER //
// ./src/components/accounts/index.js